import * as _ from 'lodash';
import { doGet } from 'utils/api';
import { RELEASES } from 'utils/environment'
const LOAD_SOFTWARE_FEED_SUCCESS = 'LOAD_SOFTWARE_FEED_SUCCESS';
const LOAD_SOFTWARE_FEED_FAIL = 'LOAD_SOFTWARE_FEED_FAIL';

const initialState = {
  products: [],
  displayErrorBanner: false,
  loading: true,
  productTree: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SOFTWARE_FEED_SUCCESS:
      return {
        ...state,
        products: action.products,
        productTree: action.productTree,
        loading: false,
      };
    case LOAD_SOFTWARE_FEED_FAIL:
      return {
        ...state,
        displayErrorBanner: true,
        loading: false,
      };
    default:
      return state;
  }
}

export function loadSoftwareFeed() {
  return dispatch => {
    let promises = RELEASES.map(feed => {
      return doGet(`products_${feed}.json`)
      .then(response => {
        return response.json()
      })
    }) 

    Promise.all(promises)
      .then(response => {
        return dispatch({
          type: LOAD_SOFTWARE_FEED_SUCCESS,
          products: response[0],
          productTree: response[1],
          });
        })
      .catch(error => {
        console.log(error);
        return dispatch({
          type: LOAD_SOFTWARE_FEED_FAIL,
        });
      });
      return false;
  }
}
